export default __webpack_public_path__ + "static/media/red.71674af6.png";